import { render, staticRenderFns } from "./AddSphere.vue?vue&type=template&id=e1ecb466&scoped=true"
import script from "./AddSphere.vue?vue&type=script&lang=js"
export * from "./AddSphere.vue?vue&type=script&lang=js"
import style0 from "./AddSphere.vue?vue&type=style&index=0&id=e1ecb466&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ecb466",
  null
  
)

export default component.exports